import styles from './MenuPedidos.module.scss';
import Botao from "../Botao";

interface Props {
    cadastrarPedido: () => void;
    verPedidos: () => void;
}

export default function MenuPedidos({cadastrarPedido, verPedidos}: Props) {
    return(
        <section className={styles.container}>
            <Botao 
                text={'Cadastrar Pedido'}
                onClick={cadastrarPedido}
            />

            <Botao 
                text={'Pedidos'}
                onClick={verPedidos}  
            />
        </section>
    )
}